export const specialStudentOPtions = ['yes', 'no']

export const event_status = [
  {
    id: 'running',
    name: 'Running',
    value: 'running',
  },
  {
    id: 'upcoming',
    name: 'Upcoming',
    value: 'upcoming',
  },
  {
    id: 'past',
    name: 'Past',
    value: 'past',
  },
  {
    id: 'cancelled',
    name: 'Cancelled',
    value: 'cancelled',
  },
]

export const transactionStatusOption = [
  {
    id: 'Pending',
    name: 'Pending',
    value: 'pending',
  },
  {
    id: 'Approved',
    name: 'Success',
    value: 'approved',
  },
  {
    id: 'Failed',
    name: 'Failed',
    value: 'failed',
  },
]

export const PROGRESS_TYPES = [
  {
    id: 'term_progress',
    name: 'Term Progress',
  },
  {
    id: 'course_progress',
    name: 'Course Progress',
  },
]

export const departmentTypes = [
  {
    id: 'academic_support',
    name: 'Academic Support',
    value: 'academic_support',
  },
  {
    id: 'billing',
    name: 'Billing',
    value: 'billing',
  },
  {
    id: 're_enrollment',
    name: 'Re-enrollment',
    value: 're_enrollment',
  },
  {
    id: 'registrars_office',
    name: 'Registrars Office',
    value: 'registrars_office',
  },
  {
    id: 'general_support',
    name: 'General Support',
    value: 'general_support',
  },
  {
    id: 'course_completion',
    name: 'Course Completion',
    value: 'course_completion',
  },
]

export const enrollmentOptions = [
  {
    id: 'assign',
    name: 'Assigned',
    value: 'assign',
  },
  {
    id: 'plan',
    name: 'Planned',
    value: 'plan',
  },
]

export const emiDuration = [
  { id: 1, value: 1 },
  { id: 2, value: 2 },
  { id: 3, value: 3 },
  { id: 4, value: 4 },
  { id: 5, value: 5 },
  { id: 6, value: 6 },
]

export const dropReasons = [
  // 'OverdueBalance',
  // 'GradeLevelBalanceOwed',
  // 'BuyOut',
  // 'AccountPaidFull',
  // 'Cancellation',
  'Cancellation & Refund (Within first 10 days of initial enrollment only)',
  'Program Withdrawal',
]

export const cancellationReasons = [
  'Financial Difficulties',
  'Personal/Family Issues',
  'Academic Challenges',
  'Dissatisfaction w/ Program',
  'Work/Time Commitments',
  'Lack of Motivation',
  'Switching Schools/Program',
  'Technical Difficulties',
]

export const academicTracks = ['ap_de', 'honors', 'regular']

export const paymentTypes = [
  {
    id: '1',
    name: 'Pay in full',
  },
  {
    id: '2',
    name: 'Pay in Installments',
  },
]

export const EVENTS_VIEW_TYPE = {
  CALENDAR: 'calendar',
  LIST: 'list',
}
